import { IGetState, TCardId, TColorId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import {
    getAuthUserAllowColorTagCount
} from '../../../../../../../../store/model/authUser/selectors/getAuthUserAllowColorTagCount';
import {
    SegmentCardColorTagAddSourceValue,
    SegmentCardEvent,
    SegmentCardOptions,
    SegmentCardType
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { root } from '../../../../../../../../store/constants';
import { segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { addFeatureTrigger } from '../../../../../../polls/featurePoll/effects/addFeatureTrigger';
import { ERateFeature } from '../../../../../../../../types/rest/IUserMeta';
import { cardSaveColorTags } from '../../../../../../../../rest/effects/card/card/cardSaveColorTags';
import {
    boardUserMetaAddRecentColorTag
} from '../../../../../../../../rest/effects/board/boardUserMetaAddRecentColorTag';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';

export const onToggleColorTag = (
    cardId: TCardId,
    colorTagId: TColorId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const colorIds = [...getCard(state, cardId).colorIds];
        const maxCount = getAuthUserAllowColorTagCount(state);
        const count = colorIds.length;
        if (colorIds.includes(colorTagId)) {
            if (
                root.App.controller.allowCounterSnackbarHelper.isShowSnackbar('allowColorTagCount') &&
                count > maxCount
            ) {
                return Promise.resolve(false);
            } else {
                colorIds.splice(colorIds.indexOf(colorTagId), 1);
                dispatch(segmentTrackAction(SegmentCardEvent.REMOVE_COLOR_TAG, {
                    name: SegmentCardOptions.SOURCE,
                    value: SegmentCardColorTagAddSourceValue.INITIAL
                }, [{
                    name: SegmentCardOptions.COUNT,
                    value: count
                }, {
                    name: SegmentCardOptions.TYPE,
                    value: SegmentCardType.CARD_DROPDOWN
                }]));
                dispatch(addFeatureTrigger(ERateFeature.COLOR_TAGS));
                return dispatch(cardSaveColorTags(cardId, colorIds)).then(() => {
                    dispatch(boardUserMetaAddRecentColorTag(getBoardIdByCardId(state, cardId), colorTagId));
                    return Promise.resolve(true);
                });
            }
        } else {
            if (count >= maxCount) {
                dispatch(showSnoozeBlocker({ allow: 'allowColorTagCount' }));
            } else {
                colorIds.push(colorTagId);
                dispatch(segmentTrackAction(SegmentCardEvent.ADD_COLOR_TAG, {
                    name: SegmentCardOptions.SOURCE,
                    value: SegmentCardColorTagAddSourceValue.INITIAL
                }, [{
                    name: SegmentCardOptions.COUNT,
                    value: count
                }, {
                    name: SegmentCardOptions.TYPE,
                    value: SegmentCardType.CARD_PREVIEW
                }]));
                dispatch(addFeatureTrigger(ERateFeature.COLOR_TAGS));
                return dispatch(cardSaveColorTags(cardId, colorIds)).then(() => {
                    dispatch(boardUserMetaAddRecentColorTag(getBoardIdByCardId(state, cardId), colorTagId));
                    return Promise.resolve(true);
                });
            }
        }
    };

    return action;
};
